export const PERMS = {
    READ: 'document_types.read',
    UPDATE: 'document_types.update',
    DELETE: 'document_types.delete',
    CREATE: 'document_types.create',
    EXPORT: 'document_types.export',
}
